import { InsurancePolicyProviderType } from '@/shared/enums';
import { fetch } from '@/shared/fetch';
import { InsurancePolicyProviderDetailsDto } from '../types/InsurancePolicyProviderDetailsDto';

type FetchInsurancePolicyProviderDetailsProps = {
    insurancePolicyProviderType: InsurancePolicyProviderType;
};

export const fetchInsurancePolicyProviderDetails = ({
    insurancePolicyProviderType,
}: FetchInsurancePolicyProviderDetailsProps) => {
    const url = `/api/caregiverspace/insurancePolicyProviders/${insurancePolicyProviderType}/details`;
    return fetch<InsurancePolicyProviderDetailsDto>(url);
};
